<template>
  <div class="customerList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <div class="total_con">
      <el-form :inline="true">
        <el-form-item label="交易返佣总金额:"><p>{{ totalNum.total }}</p></el-form-item>
      </el-form>
    </div>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import UPDATE from '@/components/page/update'
import Url from '@/views/agent/util/url'
import DateUtil from '@/utils/dataUtil'
import slotLevel from '@/views/agent/components/slotLevel.vue'

export default {
  name: 'rebateLevel',
  components: {
    FORM,
    tablePage,
    UPDATE,
  },
  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '结算代理編碼', field: 'agentCode' },
          { title: '所属代理編碼', field: 'parentCode' },
          {
            title: '时间',
            field: 'time',
            type: 6,
            format: 'yyyy-MM-dd HH:mm:ss',
            startEndParam: ['startTime', 'endTime']
          },
          { click: window.$t('common.search') }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.adAgent.rebateLevel,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { title: '结算代理编码', field: 'agentCode' },
          { title: '结算代理名称', field: 'agentName' },
          { title: '级别', field: 'level' },
          { title: '所属一级代理编码', field: 'parentCode' },
          { title: '所属一级代理名称', field: 'parentAgentName' },
          { title: '直客交易返佣', field: 'directRebateTotal' },
          { title: '其他代理分成返佣', field: 'otherRebateTotal' },
          {
            title: '开始时间', field: 'startTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '结束时间', field: 'endTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '总交易返佣（包含下级代理总分成）', field: 'rebateTotal' },
        ]
      },
      totalNum: {}
    }
  },
  methods: {
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        data.startTime = data.startTime ? new Date(data.startTime).getTime() : ''
        data.endTime = data.endTime ? new Date(data.endTime).getTime() : ''
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      }
      this.getTotalNum(data)
    },
    getTotalNum(option) {
      this.$axios.get(Url.adAgent.rebateDetailTotal, {params:option}).then(res => {
        if (res.code == 0) {
          this.totalNum = res.result
        }
      })
    },
  },
  mounted() {
    this.getTotalNum({})
  }
}
</script>

<style>
.customerList .total_con {
  width: 96%;
  margin: 0 auto;
}
.customerList .total_con .el-form-item {
  margin: 0 30px 0 0;
}
.customerList .total_con p {
  color: #ff5500;
  font-size: 16px;
  font-weight: bolder;
}
</style>
